import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  DialogContentText,
  Box,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import CustomIconButton from "../../../Components/CustomIconButton";
import CustomContainedButton from "../../../Components/CustomContainedButton";
import { ArrowBack, ArrowRight } from "@mui/icons-material";
import { ObjectValues } from "../../login";

type ContentConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (validator_remark: string) => void;
  actionType: "corrected" | "noChange"; // New prop to determine the action type
  row?: any; // Optional row data
  isSubmitting: boolean;
  newPath:ObjectValues;
  filters:ObjectValues;

};

const ContentConfirmationDialog: React.FC<ContentConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  actionType,newPath,filters,
  isSubmitting,
}) => {
  const [remark, setRemark] = useState("");
  // const [notifyUsers, setNotifyUsers] = useState(false);

  const handleConfirm = () => {
    onConfirm(remark);
  };

  useEffect(() => {
    setRemark("");
  }, [open]);
  return (
    <Dialog
      sx={{
        "& .MuiDialog-container": {
          backdropFilter: "blur(3px)", // subtle blur
        },
      }}
      open={open}
      onClose={(event, reason) => {
        if (isSubmitting) {
          return;
        }
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      BackdropProps={{
        style: { pointerEvents: isSubmitting ? "none" : "auto" },
      }}
    >
      <DialogTitle>
        {actionType === "corrected"
          ? "Mark as Corrected"
          : "No Changes Required"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
           
                {newPath&&newPath?.subtopic&&<Typography variant="body1">
                                 Along with the changes Question will be  <strong>
                                    {newPath?.subtopic ?  " moved to another path mentioned below." : ""}
                                  </strong>
                                </Typography>}
         
             {newPath && (
                                <Box
                                  sx={{
                                    mt: 2,
                                    mb: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                  }}
                                >
                                  {/* Previous hierarchy (source) */}
                                  <Box
                                    sx={{
                                      flex: 1,
                                      bgcolor: "#f5f5f5",
                                      borderRadius: 2,
                                      p: 2,
                                      minWidth: 180,
                                      border: "1px solid #e0e0e0",
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                      fontWeight={500}
                                    >
                                      Current Path
                                    </Typography>
                                    <Typography sx={{ mt: 0.5 }}>
                                      {filters.exam} • {filters.goal} • {filters.section} •{" "}
                                      {filters.topic} •{" "}
                                      <Typography
                                        component="span"
                                        fontWeight="bold"
                                        display="inline"
                                      >
                                        {filters.subtopic}
                                      </Typography>
                                      {" • "}
                                      <Typography
                                        component="span"
                                        fontWeight="bold"
                                        display="inline"
                                      >
                                        {filters.cluster?.name}
                                      </Typography>
                                      {filters.cluster?.type ? (
                                        <>
                                          {" ("}
                                          <Typography component="span" display="inline">
                                            {filters.cluster.type}
                                          </Typography>
                                          {")"}
                                        </>
                                      ) : null}
                                    </Typography>
                                    {filters.cluster?.description && (
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ mt: 0.5 }}
                                      >
                                        {filters.cluster.description}
                                      </Typography>
                                    )}
                                  </Box>
            
                                  {/* Arrow */}
                                  <Box
                                    sx={{ display: "flex", alignItems: "center", px: 1 }}
                                  >
                                    <ArrowRight sx={{ fontSize: 32, color: "#1976d2" }} />
                                  </Box>
            
                                  {/* New hierarchy (destination) */}
                                  <Box
                                    sx={{
                                      flex: 1,
                                      bgcolor: "#e3f2fd",
                                      borderRadius: 2,
                                      p: 2,
                                      minWidth: 180,
                                      border: "1px solid #90caf9",
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      color="primary"
                                      fontWeight={500}
                                    >
                                      Destination Path
                                    </Typography>
                                    <Typography sx={{ mt: 0.5 }}>
                                      {newPath.exam} • {newPath.goal} • {newPath.section} •{" "}
                                      {newPath.topic} •{" "}
                                      <Typography
                                        component="span"
                                        fontWeight="bold"
                                        display="inline"
                                      >
                                        {newPath.subtopic}
                                      </Typography>
                                      {" • "}
                                      <Typography
                                        component="span"
                                        fontWeight="bold"
                                        display="inline"
                                      >
                                        {newPath.cluster?.name}
                                      </Typography>
                                      {newPath.cluster?.type ? (
                                        <>
                                          {" ("}
                                          <Typography component="span" display="inline">
                                            {newPath.cluster.type}
                                          </Typography>
                                          {")"}
                                        </>
                                      ) : null}
                                    </Typography>
                                    {newPath.cluster?.description && (
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ mt: 0.5 }}
                                      >
                                        {newPath.cluster.description}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                              )}
                              
                               
            <Typography variant="body2" sx={{ mt: 1 }}>
              <em>Note:</em> Once submitted, this question will be{" "}
              <strong>published </strong>
              and immediately <strong> visible in the NetPractice app{newPath&&newPath.subtopic?` under destination Path.`:"."} </strong>
              Please review carefully before proceeding.
            </Typography> <Typography> Please enter a remark</Typography>
          </Box>
        </DialogContentText>
        <Stack
          spacing={2}
          style={{
            marginTop: "10px",
            pointerEvents: isSubmitting ? "none" : "auto",
          }}
        >
          <TextField
            label={
              actionType === "corrected"
                ? "Remark on Changes"
                : "Explanation for No Changes"
            }
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            multiline
            rows={4}
            fullWidth
          />
          {/* {actionType === "corrected" ? (
            <Stack>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={notifyUsers}
                    onChange={(e) => setNotifyUsers(e.target.checked)}
                    style={{ color: "#000000" }}
                  />
                }
                label="Send notification to all users who have attempted this question"
              />
            </Stack>
          ) : (
            <></>
          )} */}
        </Stack>
      </DialogContent>
      <DialogActions>
        <CustomIconButton
          variant="outlined"
          content={"Cancel"}
          sx={{ minWidth: "fit-content", mr: "5px" }}
          onClick={onClose}
          icon={<ArrowBack sx={{ height: "16px" }} />}
          disabled={isSubmitting}
        />
        <CustomContainedButton
          otherProps={{
            disabled: isSubmitting,
            onClick: handleConfirm,
            sx: { minWidth: "60px" },
          }}
          icon="Submit"
          content={<PlaylistAddCheckOutlinedIcon sx={{ height: "16px" }} />}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ContentConfirmationDialog;
